import { Address } from '@adornis/address/db/address.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity } from '@adornis/baseql/decorators.js';
import { getMenteeUserClass, getMentorUserClass } from '@adornis/bh-matching-user/user-class.js';
import { ExportDataView } from '@adornis/data-view/db/export-data-view.js';
import type { Translator } from '@adornis/translation-core/translation.js';
import { format } from 'date-fns';

export const BUDDY_EXPORT_ENUM_FIELDS = [
  'gender',
  'genderPreference',
  'department',
  'preferredLanguage',
  'mentorSprache',
  'angestrebterAbschluss',
  'firstTime',
  'meetingType',
  'searchingWork',
  'firstGenerationStudent',
  'naechsteKarriereschritte',
  'menteeSemester',
  'extraSubject',
  'extraSubjectSonstiges',
  'mainSubject',
  'foreignLanguages',
  'privacyPolicy',
  'languageC1',
  'minSemesterPrerequisite',
  'immigrantHistory',
  'studiedAbroad',
  'erasmusStudent',
  'firstTime',
  'international',
  'goetheStudent',
  'abschlussarbeitBetreuen',
  'workIntegratedLeaning',
  'internationalMentees',
];
export const BUDDY_EXPORT_ENUM_LIST_FIELDS = ['whatIsNeededFromMentor', 'menteeDepartments'];
export const BUDDY_EXPORT_STRING_FIELDS = ['matrikelNummer', 'phoneNumber', 'phone', 'menteeSemester', 'birthday'];

@Entity()
export class BuddyExportDataView extends ExportDataView {
  static override _class = 'BuddyExportDataView';

  static override translateValue(field: string, value: any) {
    // console.log('translate value', field, value, typeof value);
    const translator = this._translator as Translator<any>;
    let translatedStr: Maybe<string> = null;

    if (value === null || value === undefined) return '';
    // nur mentee => mentorSprache, "profilbild"(id), "lebenslauf"(id)
    // nur mentor => menteeDepartments,
    // weitere =>, extraSubject, extraSubject, expectedGraduationMonth
    // müssen Boolean => minSemesterPrerequisite, extraSubjectSonstiges,

    if (value === getMenteeUserClass()._class) return translator.translate('user', value);
    if (value === getMentorUserClass()._class) return translator.translate('user', value);

    if (!!value && typeof value === 'boolean') value = value ? 'JA' : 'NEIN';

    if (typeof value === 'string') {
      const tmp = translator.translate('enums', value);
      if (!tmp.startsWith('enums.')) translatedStr = tmp;
      else if (value.includes(', ')) {
        const orgs = value.split(', ');
        const news = [] as string[];
        let didMatch = false;
        for (const org of orgs) {
          const temp = translator.translate('enums', org);
          if (!temp.startsWith('enums.')) {
            news.push(temp);
            didMatch = true;
          } else {
            news.push(org);
          }
        }
        if (didMatch) translatedStr = news.join(', ');
      }
    }

    if (Array.isArray(value)) {
      console.log('value is array');
      translatedStr = value
        .map(curEnum => {
          const temp = translator.translate('enums', curEnum);
          if (!temp.startsWith('enums.')) return temp;
          return curEnum;
        })
        .join(', ')
        .replaceAll('undefined', '')
        .replaceAll('null', '');

      console.log('translatedStr', translatedStr);
    }

    if (BUDDY_EXPORT_ENUM_LIST_FIELDS.includes(field) && !!value)
      translatedStr = (value as string)
        .split(', ')
        .map(curEnum => translator.translate('enums', curEnum))
        .join(', ');

    //if (field === 'academicDegree') return safeGetFirst(ACADEMIC_DEGREE, value);
    if (field === 'address' && !!value && typeof value === 'object') {
      const mabyeAdress = value as Maybe<Address>;
      if (mabyeAdress?._class === Address._class) {
        const zipCity = mabyeAdress.zipCity;

        const street = mabyeAdress['streetAndHousenumber']?.toString();
        const zip = zipCity?.['zip']?.toString();
        const city = zipCity?.['city']?.toString();

        translatedStr = [street, `${zip} ${city}`]
          .filter(str => !!str)
          .join(', ')
          .replaceAll('undefined', '')
          .replaceAll('null', '');
      }
    }
    //if (typeof value === 'boolean') return value[field] ? 'Wahr' : 'Falsch';
    if (value instanceof Date) {
      const formattedDate = format(value, field === 'birthday' ? 'P' : 'Pp');
      translatedStr = `${formattedDate}`;
    }

    if (!translatedStr && BUDDY_EXPORT_STRING_FIELDS.includes(field) && !!value)
      translatedStr = `\t${translatedStr ?? value}`;

    if (!translatedStr) return super.translateValue(field, value);
    if (translatedStr === 'enums') return '';
    return translatedStr;
  }
}
